import * as React from "react";
import { CalloutRunningProcess } from "./CalloutRunningProcess";
export var CalloutBuilding = function (_a) {
    var building = _a.building;
    return React.createElement(CalloutRunningProcess, { building: building });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/callouts/CalloutBuilding.tsx
// module id = 2235
// module chunks = 3